import { defineStore } from "pinia";
import subastaModel from "@/models/subastaModel";
import loteModel from "@/models/loteModel";
import categoriaModel from "../models/categoriaModel";

export const useCarteleraStore = defineStore("carteleraStore", {
  state: () => ({
    subastas: {
      data: [],
      current_page: 1,
      first_page_url: null,
      from: null,
      last_page: null,
      per_page: 10,
      to: null,
      total: null,
    },
    lotes: {
      data: [],
      current_page: 1,
      first_page_url: null,
      from: null,
      last_page: null,
      per_page: 12,
      to: null,
      total: null,
    },
    categoriasLotes: [],
    subastasDestacadas: [],
    filtrosLotes: {},
    cargando: true,
  }),
  actions: {
    async getSubastas(filtros = {}) {
      try {
        this.cargando = true;
        const filtrosClonados = {
          ...filtros,
          page: this.subastas.current_page,
          per_page: this.subastas.per_page,
        };

        const subastas = await subastaModel.getSubastas(filtrosClonados);

        if (subastas) {
          this.subastas.data = subastas.data;
          this.subastas.current_page = subastas.current_page;
          this.subastas.first_page_url = subastas.first_page_url;
          this.subastas.from = subastas.from;
          this.subastas.last_page = subastas.last_page;
          this.subastas.per_page = subastas.per_page;
          this.subastas.to = subastas.to;
          this.subastas.total = subastas.total;
        }
      } catch (error) {
        console.error("Error al obtener subastas:", error);
        throw error;
      } finally {
        this.cargando = false;
      }
    },

    async getLotes(filtros = {}) {
      try {
        this.cargando = true;
        const filtrosClonados = {
          ...filtros,
          page: filtros.page ?? this.lotes.current_page,
          per_page: filtros.per_page ?? this.lotes.per_page,
        };

        this.filtrosLotes = { ...filtrosClonados };

        const lotes = await loteModel.obtenerLotes(filtrosClonados);

        if (lotes) {
          Object.assign(this.lotes, lotes);
        }
      } catch (error) {
        console.error("Error al obtener lotes:", error);
        throw error;
      } finally {
        this.cargando = false;
      }
    },

    async obtenerCategoriasLotes() {
      try {
        const categorias = await categoriaModel.obtenerCategoriasLotes();
        this.categoriasLotes = categorias.data;
      } catch (error) {
        console.log("error al obtener categorias de los lotes", error);
      }
    },

    async getSubastasDestacadas() {
      const subastas = await subastaModel.getSubastas();
      if (subastas) {
        this.subastasDestacadas = subastas.data;
      }
    },

    async updatePaginationSubastas(field, value) {
      if (field === "current_page" || field === "per_page") {
        this.subastas[field] = value;
        await this.getSubastas();
      }
    },
    async updatePaginationLotes(field, value, filtros = {}) {
      if (field === "current_page") this.lotes.current_page = value;
      else if (field === "per_page") this.lotes.per_page = value;

      const prev = this.filtrosLotes || {};

      let next = {
        ...prev,
        ...filtros,
        page: this.lotes.current_page,
        per_page: this.lotes.per_page,
      };

      if ("tipificado_id" in filtros) {
        const arr = filtros.tipificado_id;
        if (Array.isArray(arr) && arr.length > 0) {
          delete next["tipificado:categoria_id"];
        } else {
          delete next.tipificado_id;
        }
      } else if ("tipificado:categoria_id" in filtros) {
        delete next.tipificado_id;
      } else if (
        !("tipificado_id" in filtros) &&
        !("tipificado:categoria_id" in filtros)
      ) {
        delete next.tipificado_id;
      }

      if ("subasta_ubicacion_id" in filtros) {
        const ubis = filtros.subasta_ubicacion_id;
        if (!Array.isArray(ubis) || ubis.length === 0) {
          delete next.subasta_ubicacion_id;
        }
      } else if (prev.subasta_ubicacion_id) {
        delete next.subasta_ubicacion_id;
      }

      this.filtrosLotes = next;
      await this.getLotes(next);
    },
    async aplicarSubastasActualizadas(event = {}) {
      const incoming = event.subastas;
      if (!incoming) return;

      const paginaActual = Number(this.subastas.current_page ?? 1);
      const paginaEvento = Number(incoming.current_page ?? 1);

      if (paginaActual === paginaEvento) {
        Object.assign(this.subastas, incoming);
        return;
      }

      await this.actualizarSubastasSilencioso();
    },

    async aplicarLotesActualizados(event = {}) {
      const incoming = event.lotes;
      if (!incoming) return;

      const paginaActual = Number(this.lotes.current_page ?? 1);
      const paginaEvento = Number(incoming.current_page ?? 1);

      if (paginaActual === paginaEvento) {
        Object.assign(this.lotes, incoming);
        return;
      }

      await this.actualizarLotesSilencioso();
    },

    aplicarDestacadasActualizadas(event = {}) {
      if (!event.destacadas) return;
      this.subastasDestacadas = event.destacadas;
    },

    async actualizarLotesSilencioso() {
      const paginaActual = this.lotes.current_page;
      const perPageActual = this.lotes.per_page;

      const filtrosClonados = {
        ...(this.filtrosLotes ?? {}),
        page: paginaActual,
        per_page: perPageActual,
      };

      const lotes = await loteModel.obtenerLotes(filtrosClonados);

      if (!lotes) return;

      Object.assign(this.lotes, {
        ...lotes,
        current_page: paginaActual,
        per_page: perPageActual,
      });
    },

    async actualizarSubastasSilencioso() {
      const paginaActual = this.subastas.current_page;
      const perPageActual = this.subastas.per_page;

      const filtrosClonados = {
        ...(this.filtrosSubastas ?? {}),
        page: paginaActual,
        per_page: perPageActual,
      };

      const subastas = await subastaModel.getSubastas(filtrosClonados);

      if (!subastas) return;

      Object.assign(this.subastas, {
        ...subastas,
        current_page: paginaActual,
        per_page: perPageActual,
      });
    }
  },
  getters: {},
});
